import React from "react";
import ListViewTable from "../../../../../shared/components/ListViewTable";
import { TopProductRow } from "./TopProductRow";

const TableColumns = [
    { text: "Top", icon: <></> },
    { text: "Tên sản phẩm", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "Chiếm %", icon: <></> },
];

interface TopProductsTableProps {
    category: string;
}

const TopProductsTable = ({ category }: TopProductsTableProps) => {
    return (
        <ListViewTable
            url={`/dashboard/products/top/5/?category=${category}`}
            rowElement={TopProductRow}
            tableColumns={TableColumns}
            subTitleText="Top 5 sản phẩm bán chạy nhất"
        />
    );
};

export default TopProductsTable;
